import { lockScroll, unlockScroll } from '@theme/utilities';

class ClendoCollectionFilters extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.mobile = matchMedia('(max-width:749px)');
    this.mobile.addEventListener('change', () => this.placeForm(), { signal });
    this.addEventListener('click', event => {
      if (event.target.closest('[data-open-filters]')) this.open();
      if (event.target.closest('[data-close-filters]')) this.close();
      if (event.target === this.dialog) {
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.close();
      }
    }, { signal });
    this.dialog.addEventListener('close', () => this.afterClose(), { signal });
    this.closest('.shopify-section')?.addEventListener('clendo:before-section-morph', event => {
      const incoming = event.detail.newElement.querySelector('clendo-collection-filters');
      if (!incoming) return;
      incoming.setAttribute('data-enhanced', '');
      if (this.mobile.matches) incoming.querySelector('[data-filter-dialog-content]').append(incoming.querySelector('.clendo-shared-facets'));
      this.syncSortControls(incoming);
    }, { signal });
    this.setAttribute('data-enhanced', '');
    this.placeForm();
  }
  disconnectedCallback() {
    this.controller?.abort();
    if (this.dialog?.open) unlockScroll(this.dialog);
  }
  get dialog() { return this.querySelector('.clendo-filter-dialog'); }
  syncSortControls(root = this) {
    // Only the visible sorting control participates in the shared form.
    for (const input of root.querySelectorAll('[name="sort_by"]')) {
      const mobileControl = Boolean(input.closest('.clendo-filter-mobile-sort'));
      input.disabled = mobileControl !== this.mobile.matches || (mobileControl && input.tagName !== 'SELECT');
    }
  }
  placeForm() {
    if (!this.mobile.matches && this.dialog.open) this.close();
    const form = this.querySelector('.clendo-shared-facets');
    const target = this.querySelector(this.mobile.matches ? '[data-filter-dialog-content]' : '[data-filter-home]');
    if (form && form.parentElement !== target) target.append(form);
    this.syncSortControls();
  }
  open() {
    if (!this.mobile.matches || this.dialog.open) return;
    this.placeForm();
    this.trigger = this.querySelector('[data-open-filters]');
    this.trigger.setAttribute('aria-expanded', 'true');
    this.dialog.showModal();
    lockScroll(this.dialog);
  }
  close() { this.dialog.close(); this.afterClose(); }
  afterClose() {
    unlockScroll(this.dialog);
    this.querySelector('[data-open-filters]')?.setAttribute('aria-expanded', 'false');
    if (this.mobile.matches) this.trigger?.focus();
  }
}
if (!customElements.get('clendo-collection-filters')) customElements.define('clendo-collection-filters', ClendoCollectionFilters);
